var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomthingWrongCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 203,
    height: 117
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "somthing-wrong-cancel_svg__c",
    x1: "-23.362%",
    x2: "130.472%",
    y1: "63.707%",
    y2: "34.581%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "29.042%",
    stopColor: "#FFB480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "somthing-wrong-cancel_svg__d",
    x1: "123.205%",
    x2: "15.026%",
    y1: "14.72%",
    y2: "85.28%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF8294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF4057"
  })), /*#__PURE__*/React.createElement("path", {
    id: "somthing-wrong-cancel_svg__a",
    d: "M0 0h203v117H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "somthing-wrong-cancel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#somthing-wrong-cancel_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#somthing-wrong-cancel_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB74",
    d: "M142.148 5.382h8.832c10.9 0-7.35-3.11 0-3.11h39.891c37.215 0 49.734.282 33.524 3.11-16.21 2.827-14.281.848 14.851 0 29.132-.849 15.506 5.839-17.38 5.839-32.887 0-124.48 2.266-107.234 0 11.497-1.511 28.833-2.835 52.006-3.971l-24.49-1.868z",
    opacity: 0.172
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#somthing-wrong-cancel_svg__c)",
    d: "M.665 116.367c2.432-20 14.723-30 36.874-30 33.226 0 35.955-28.35 58.297-39.523 22.342-11.173 30.647 7.374 54.957-9.31 24.31-16.685 42.228-30.976 68.375-17.927 17.431 8.7 20.317 40.953 8.658 96.76H.665z",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FCFE",
    d: "M43.563 22.493a7.249 7.249 0 00-6.62 4.296 3.91 3.91 0 00-6.087 1.257 2.895 2.895 0 00-3.882 2.24c-.361.327-.784.696-1.265 1.104-1.684 1.43-7.598 2.181-17.742 2.256l21.831-.001.033.001h.035l4.48-.001.034.001h.034l18.135-.001.034.001h18.772c-6.37-.188-11.54-.773-15.513-1.753a3.908 3.908 0 00-5.706-5.203 7.243 7.243 0 00-6.573-4.197z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.34 19.515)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#811623",
    d: "M.337 34.56h70.272v38.016c0 1.06-.86 1.92-1.92 1.92H2.257a1.92 1.92 0 01-1.92-1.92V34.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.296,
    height: 56.064,
    x: 7.68,
    y: 0.241,
    fill: "#F8FCFE",
    rx: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FABEC8",
    d: "M21.528 34.335h27.6v2.4h-27.6zm3 6h21.6v2.4h-21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF475D",
    d: "M70.609 34.56v38.016c0 1.06-.86 1.92-1.92 1.92H2.357a.384.384 0 01-.191-.717L70.609 34.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6C80",
    d: "M.337 34.56v38.016c0 1.06.86 1.92 1.92 1.92h66.331a.384.384 0 00.191-.717L.337 34.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D02E41",
    d: "M35.473 54.694l33.306 19.085a.384.384 0 01-.191.717H2.357a.384.384 0 01-.191-.717l33.307-19.085z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#somthing-wrong-cancel_svg__d)",
    d: "M25.63 27.867h20.83a2 2 0 001.703-3.047L37.75 7.87a2 2 0 00-3.408-.001L23.926 24.82a2 2 0 001.704 3.047z",
    transform: "translate(75 19)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Lato-Black, Lato",
    fontSize: 12,
    fontWeight: 700,
    transform: "translate(75 19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.744,
    y: 24
  }, "!"))))));
}
export default SvgSomthingWrongCancel;